/*
 * Free-Products im Cart-Drawer.
 * Reagiert auf co2.cart.initialized (feuert verlässlich nach allen Cart-DOM-Updates).
 * Auto-Remove invalider Gifts via Dawn's <cart-remove-button>.
 */
(function () {
  /* Trailing-edge: während ein Cycle läuft, kommende Events nur als pending markieren. */
  var isHandling = false;
  var pending = false;

  /* ─── Helpers ───────────────────────────────────────────────── */

  function getRoot() {
    return document.querySelector('[data-free-products-root]');
  }

  function hideFreeProductArea() {
    var root = getRoot();
    if (!root) return;
    root.hidden = true;
    root.innerHTML = '';
    root.classList.remove('cart-drawer__free-products--progress');
    root.classList.remove('cart-drawer__free-products--reached');
  }

  function showFreeProductArea(html, stateClass) {
    var root = getRoot();
    if (!root) return;
    root.innerHTML = html;
    root.classList.remove('cart-drawer__free-products--progress');
    root.classList.remove('cart-drawer__free-products--reached');
    root.classList.add(stateClass);
    root.hidden = false;
  }

  function findProduct(products, handle) {
    return products.find(function (p) { return p.handle === handle; });
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function pickText(root, singularKey, pluralKey, usePlural) {
    return usePlural ? root.dataset[pluralKey] : root.dataset[singularKey];
  }

  function withAmount(template, amount) {
    // Template escapen, Money-HTML (transcy-money) als Marker-Platzhalter durchschleusen
    var PLACEHOLDER = '___AMOUNT_PLACEHOLDER___';
    var escaped = escapeHtml(String(template).replace(/\{\{\s*amount\s*\}\}/g, PLACEHOLDER));
    return escaped.split(PLACEHOLDER).join(formatPrice(amount));
  }

  function filterRenderableGroups(groups) {
    if (!groups) return [];
    return groups.filter(function (g) {
      return g && g.addAutomatically !== true && g.productItems && g.productItems.length > 0;
    });
  }

  /* ─── Render ────────────────────────────────────────────────── */

  function renderProductPreview(product) {
    if (!product) return '';
    return (
      '<div class="cart-drawer__free-products__preview">' +
        '<div class="cart-drawer__free-products__image">' +
          '<img src="' + escapeHtml(product.image || '') + '"' +
          ' alt="' + escapeHtml(product.title || '') + '" width="52" height="52" loading="lazy">' +
        '</div>' +
        '<div class="cart-drawer__free-products__title">' + escapeHtml(product.title || '') + '</div>' +
      '</div>'
    );
  }

  /* nextFreeProducts() liefert { threshold, sub_total, items: [groups] } */
  function renderProgressState(nextObj, products) {
    var root = getRoot();
    if (!root) return;

    var groups = filterRenderableGroups(nextObj && nextObj.items);
    if (groups.length === 0) {
      hideFreeProductArea();
      return;
    }

    var usePlural = groups.length > 1 || (groups[0].unredeemedQty && groups[0].unredeemedQty > 1);
    var diff = nextObj.threshold - nextObj.sub_total;
    var headlineText = withAmount(pickText(root, 'textRemainingSingular', 'textRemainingPlural', usePlural), diff);

    var previewsHtml = groups
      .map(function (g) { return renderProductPreview(findProduct(products, g.productItems[0])); })
      .join('');

    showFreeProductArea(
      '<div class="cart-drawer__free-products__headline cart-drawer__free-products__headline--progress">' +
        headlineText +
      '</div>' +
      '<div class="cart-drawer__free-products__previews">' + previewsHtml + '</div>',
      'cart-drawer__free-products--progress'
    );
  }

  function renderReachedState(group, products, totalUnredeemedCount) {
    var root = getRoot();
    if (!root) return;

    var usePlural = totalUnredeemedCount > 1 || (group.unredeemedQty && group.unredeemedQty > 1);
    var headlineText = pickText(root, 'textReachedSingular', 'textReachedPlural', usePlural);
    var buttonLabel = root.dataset.textChooseButton;
    var orLabel = root.dataset.textOr;
    var shopRoot = (Shopify.routes && Shopify.routes.root) || '/';

    var alternativesHtml = group.productItems
      .map(function (handle, index) {
        var product = findProduct(products, handle);
        if (!product) return '';
        var productUrl = shopRoot + 'products/' + product.handle;
        var html =
          '<div class="cart-drawer__free-products__alternative">' +
            renderProductPreview(product) +
            '<button type="button" class="cart-drawer__free-products__btn button--primary"' +
              ' data-atc-modal-trigger data-product-url="' + escapeHtml(productUrl) + '" data-gift="true">' +
              '<span>' + escapeHtml(buttonLabel) + '</span>' +
              '<span class="loading__spinner hidden">' +
                '<svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">' +
                  '<circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>' +
                '</svg>' +
              '</span>' +
            '</button>' +
          '</div>';
        if (index < group.productItems.length - 1 && group.productItems.length > 1) {
          html += '<div class="cart-drawer__free-products__or" aria-hidden="true">' + escapeHtml(orLabel) + '</div>';
        }
        return html;
      })
      .join('');

    showFreeProductArea(
      '<div class="cart-drawer__free-products__headline cart-drawer__free-products__headline--reached">' +
        escapeHtml(headlineText) +
      '</div>' +
      '<div class="cart-drawer__free-products__alternatives">' + alternativesHtml + '</div>',
      'cart-drawer__free-products--reached'
    );
  }

  /* ─── Auto-Remove ───────────────────────────────────────────── */

  /* Marker → Line-Item via data-line-item-key → click() auf cart-remove-button.
     Dawn's CartRemoveButton ruft cartItems.updateQuantity(line, 0) → fetch + Section-
     Rerender + publish(cartUpdate). Datora-Bridge → neuer co2.cart.initialized → nächster
     Cycle hier (via pending im trailing-edge wrapper). */
  function autoRemoveInvalidGift() {
    var marker = document.querySelector('[data-gift-remove-key]');
    if (!marker) return false;
    var lineEl = document.querySelector(
      '.cart-drawer__line-item[data-line-item-key="' + marker.dataset.giftRemoveKey + '"]'
    );
    if (!lineEl) return false;
    var removeBtn = lineEl.querySelector('cart-remove-button');
    if (!removeBtn) return false;
    removeBtn.click();
    return true;
  }

  /* ─── Main Cycle ────────────────────────────────────────────── */

  async function updateFreeProductUI() {
    var unredeemed = filterRenderableGroups(await co2.unredeemedFreeProducts());
    var nextRaw = await co2.nextFreeProducts();
    var nextGroups = filterRenderableGroups(nextRaw && nextRaw.items);

    if (unredeemed.length === 0 && nextGroups.length === 0) {
      hideFreeProductArea();
      return;
    }

    var products = (await co2.freeProductData()) || [];

    if (unredeemed.length > 0) {
      renderReachedState(unredeemed[0], products, unredeemed.length);
    } else {
      renderProgressState(nextRaw, products);
    }
  }

  async function runCycle() {
    if (autoRemoveInvalidGift()) {
      hideFreeProductArea();
      return;
    }
    await updateFreeProductUI();
  }

  async function triggerCycle() {
    if (typeof co2 === 'undefined') return;
    if (isHandling) {
      pending = true;
      return;
    }
    isHandling = true;
    try {
      do {
        pending = false;
        await runCycle();
      } while (pending);
    } finally {
      isHandling = false;
    }
  }

  /* Zwei Trigger:
     - co2.cart.initialized: co2 hat frische Daten
     - PUB_SUB_EVENTS.cartRerendered: cart-drawer-items / drawer-inner wurde neu in den
       DOM geschrieben (cart.js.onCartUpdate replaceWith, cart-drawer.renderContents).
       Bei externen cartUpdate-Sources (z. B. datora.refreshCartAndPrices) feuert co2
       u. U. vor dem replaceWith — dann wäre unser Render gewipt. Der zweite Trigger
       fängt das auf, der trailing-edge wrapper de-dupt parallele Aufrufe. */
  window.addEventListener('co2.cart.initialized', triggerCycle);
  subscribe(PUB_SUB_EVENTS.cartRerendered, triggerCycle);
})();
